export enum AppRoles {
    User = "User",
    Admin = "Admin",
    BusinessAnalyst = "BusinessAnalyst",
    AiPromptEngineer = "AiPromptEngineer",
    Hostadmin = "Hostadmin",
    KBTester = "KBTester"
}
